import {
  Box,
  Button,
  Card,
  CardActionArea,
  Chip,
  TableCell,
  TableRow,
  Typography
} from '@mui/material';
import { purple } from '@mui/material/colors';
import { emphasize, styled } from '@mui/material/styles';
import { makeStyles, withStyles } from '@mui/styles';
import Color from 'color'; // v3.2.1
import { Carousel } from 'react-responsive-carousel';

export const StyledChip = styled(Chip)(({ bgcolor, fontColor = 'white' }) => ({
  color: fontColor,
  backgroundColor: bgcolor,
  '&&:hover': {
    backgroundColor: bgcolor
  }
}));

export const useStyles = makeStyles((theme) => ({
  footerContainer: {
    backgroundColor: '#1875d1',
    width: '100%',
    overflow: 'hidden',
    marginTop: '10px',
    minHeight: '120px'
  },
  headerContainer: {
    marginTop: '12px',
    marginLeft: '12px',
    marginRight: '12px',
    justifyContent: 'center',
    display: 'flex',
    marginBottom: '12px',
    padding: '10px'
  },
  inputRoot: {
    borderRadius: 18,

    borderColor: 'red',
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
      borderColor: '#22242626',

      borderRadius: 18
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
      borderRadius: 18,
      borderColor: '#22242626'
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
      borderRadius: 18,
      borderColor: '#22242626'
    }
  },
  screenshotImage: {
    objectFit: 'scale-down !important',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  media: {
    height: '250',
    objectFit: 'cover'
  },
  nftMedia: {
    height: '450px',
    objectFit: 'contain',
    borderRadius: '12px'
  },

  nftCardHeader: {
    maxHeight: '340px'
  },
  image: {
    width: 'auto',
    height: 400,
    objectFit: 'contain'
  },
  toTop: {
    zIndex: 2,
    position: 'fixed',
    bottom: '2vh',
    backgroundColor: '#DCDCDC',
    color: 'black',
    '&:hover': {
      transition: '0.3s',
      color: '#397BA6',
      backgroundColor: '#DCDCDC'
    },
    [theme.breakpoints.up('xs')]: {
      right: '5%',
      backgroundColor: 'rgb(220,220,220,0.7)'
    },
    [theme.breakpoints.up('lg')]: {
      right: '6.5%'
    }
  },
  styledText: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  socialHandleContainer: {
    //   transform: 'translateY(250%)'
  },
  aboutContainer: {
    //  transform: 'translateY(200%)'
  },
  card: {
    minWidth: '90%',
    minHeight: '120px'
  }
}));

export const StyledTextBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  backgroundColor: 'white',
  borderRadius: '46px',
  height: '25px',
  maxWidth: '250px',
  padding: '10px',
  paddingLeft: '25px',
  paddingRight: '25px'
}));

export const StyledTableRow = withStyles(() => ({
  root: {
    height: 40
  }
}))(TableRow);

export const StyledTableCell = withStyles(() => ({
  root: {
    padding: '0px 16px!important'
  }
}))(TableCell);

export const StyledCellText = styled(Typography)(() => ({
  fontSize: '1em',
  root: {
    fontSize: '1em'
  }
}));

export const StyledTableHeaderCell = styled(TableCell)(() => ({
  color: '#374956',
  fontsize: '0.9rem',
  fontWeight: 550
}));
export const ColorButton = styled(Button)(({ theme }) => ({
  marginTop: '10px',
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: purple[500],
  '&:hover': {
    backgroundColor: purple[700]
  }
}));

export const StyledNavButton = styled(Button)(() => ({
  color: 'rgba(0, 0, 0, 0.87)',
  fontWeight: 'bold',
  fontSize: '18px !important',
  '&:hover': {
    color: 'rgb(245, 124, 0)'
  }
}));

export const CardActionAreaActionArea = styled(CardActionArea)(() => ({
  borderRadius: 16,
  transition: '0.2s',
  '&:hover': {
    transform: 'scale(1.1)'
  }
}));

export const StyledCard = styled(Card)(({ color }) => ({
  // maxWidth: 345,
  height: '100%',
  borderRadius: 16,
  boxShadow: '0 6px 12px 0 rgba(34, 35, 58, 0.2)',
  '&:hover': {
    cursor: 'pointer',
    boxShadow: `0 6px 12px 0 ${Color(color).rotate(-12).darken(0.2).fade(0.5)}`
  }
}));

export const StyledNFTCard = styled(Card)(({ color }) => ({
  width: 320,
  boxShadow: '0 2px 4px -2px rgba(0,0,0,0.24), 0 4px 24px -2px rgba(0, 0, 0, 0.2)',
  borderRadius: '12px',
  height: '100%',
  // maxHeight: '100%',
  '&:hover': {
    cursor: 'pointer',
    boxShadow: `0 6px 12px 0 ${Color(color).rotate(-12).darken(0.2).fade(0.5)}`
  }
}));

export const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06)
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12)
    }
  };
});

export const StyledCarousel = styled(Carousel)`
  & .carousel .slide img {
    max-height: 400px; /* change this to whatever you want */
    width: 400;
  }

  & .carousel .thumb {
    height: 80px;
    width: 80px;
  }
  & .carousel * {
    border-radius: 16px;
  }
`;
